import menuLocale from '@/i18n/modules/menu.i18n'

const ROUTE_META_LANG_KEY = {
  login: 'login',
  home: 'home',
  feature: 'feature',
  detail: 'detail',
  imageDetail: 'imageDetail',
  imageProcess: 'imageProcess',
  source: 'source',
  FullDbSearch: 'article',
  SubDbExplore: 'subDb',
  BookCollectionExplore: 'bookCollection',
  newspaper: 'newspaper',
  newspaperDetail: 'newspaperDetail',
  newspaperPageDetail: 'newspaperPageDetail',
  journal: 'journal',
  book: 'book',
  bookCollectionEdit: 'bookCollection',
  subject: 'subject'
}

function applyRouteMetaLang(routes, lang) {
  const visit = (list) => {
    list.forEach((route) => {
      const key = ROUTE_META_LANG_KEY[route.name]
      if (key) {
        route.__i18nTitle = (menuLocale[lang] || menuLocale.zh)[key] || route.meta.title
      } else {
        route.__i18nTitle = route.meta.title
      }
      if (Array.isArray(route.children)) visit(route.children)
    })
  }
  visit(routes)
}

export function getRouteTitle(route, language) {
  const key = ROUTE_META_LANG_KEY[route && route.name]
  const source = menuLocale[language] || menuLocale.zh
  return (key && source[key]) || (route && route.meta && route.meta.title) || ''
}

export { applyRouteMetaLang, ROUTE_META_LANG_KEY }
